module.exports = __webpack_public_path__ + "8f8129a145d05ff485dd498ce964da01.pdf";